module.exports = __webpack_public_path__ + "static/media/text.aac44d39.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/text.svg
// module id = 1445
// module chunks = 0